module.exports = __webpack_public_path__ + "static/media/amo4.cbf90af1.webp";